import React from 'react';
import PropTypes from 'prop-types';
import CardRow from '../CardRow/CardRow';
import CardRowCard from '../CardRow/CardRowCard';
import DetailWrapper from '../CardRow/DetailWrapper';
import TemplatesSettings from './TemplatesSettings/TemplatesSettings';
import Links from './Links/Links';

const NotificationWrapper = ( { notifications, handlers } ) => {
  return (
    <>
      <DetailWrapper>
        <CardRow>
          <CardRowCard>
            <TemplatesSettings
              notifications={notifications}
              handlers={handlers}
            />
          </CardRowCard>
        </CardRow>
        <CardRow>
          <CardRowCard>
            <Links />
          </CardRowCard>
        </CardRow>
      </DetailWrapper>
    </>
  );
};

NotificationWrapper.propTypes = {
  notifications: PropTypes.object,
  handlers: PropTypes.object,
};

export default NotificationWrapper;
